import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { TypeSampleType } from "../../app/types/genericTables.types";

type UseSampleType = {
  sampleTypeList: TypeSampleType[];
  get: (id: TypeSampleType["id"]) => TypeSampleType | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useTypeSample = create<UseSampleType>((set, get) => ({
  loading: false,
  sampleTypeList: [],
  query: "",
  setQuery: (query) => set({ query }),
  get: (id) => get().sampleTypeList.find((sample) => sample.id === id),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/generic/TipoMuestra";
      const { data: response } = await getData(endpoint);
      set(() => ({
        sampleTypeList: response,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching userList:", error);
      set({ loading: false });
    }
  },
}));
